module.exports = __webpack_public_path__ + "static/media/arrow-up.5a78ed09.svg";